import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  paginatedElements: 0,
  firebaseDrillCollections: {
    loading: false,
    data: [],
    errorMessage: '',
  },
  filterByDetail: ''
};

const firebasePayReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_LOADING:
      return {
        ...state,
        firebaseDrillCollections: {
          ...state.firebaseDrillCollections,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_SUCCESS:
      return {
        ...state,
        firebaseDrillCollections: {
          ...state.firebaseDrillCollections,
          loading: false,
          data: [...action.payload],
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_LIST_ERROR:
      return {
        ...state,
        firebaseDrillCollections: {
          ...state.firebaseDrillCollections,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        executeSearch: false,
        data: [...action.payload.data],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: '',
        filterByDetail: action.payload.filterByDetail
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_ERROR:
      return {
        ...state,
        loading: false,
        executeSearch: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_SEARCH:
      return {
        ...state,
        executeSearch: true,
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_SEARCH_RESET:
      return {
        ...state,
        executeSearch: false,
      };
    case REDUX_ACTIONS.FIREBASE_DRILL_COLLECTION_DATA_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default firebasePayReducer;
